<template>
    <div class="form-group form-group-with-search d-flex align-items-center">
        <span :key="'search'"
              class="form-control-feedback">
            <app-icon name="search"/>
        </span>
        <input
            type="text"
            class="form-control"
            v-model="searchValue"
            :placeholder="$t('search')"
            @keydown.enter.prevent="getSearchValue"
        />
    </div>
</template>

<script>
    export default {
        name: "AppSearch",
        props: {
            value: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                searchValue: this.value,
            }
        },
        watch: {
            value: function (value) {
                if (value !== this.searchValue) {
                    this.searchValue = value;
                }
            },
            searchValue: function (value) {
                if (value === '')
                    this.getSearchValue();
            }
        },
        methods: {
            getSearchValue() {
                this.$emit('input', this.searchValue);
            },
        }
    }
</script>
